module.exports = __webpack_public_path__ + "media/images/icons/icon-simulator-color-df256fc094b0f06fa76690f3cf3d4d0b.svg";